export const GET_COURIERS = "GET_COURIERS";
export const GET_COURIER_BY_ID = "GET_COURIER_BY_ID";
export const UPDATE_COURIER = "UPDATE_COURIER";
export const DELETE_COURIER = "DELETE_COURIER";
export const CREATE_COURIER = "CREATE_COURIER";
export const COURIER_REPLACE = "COURIER_REPLACE";
export const EMAIL_SEND = "EMAIL_SEND";
export const EMAIL_HTML = "EMAIL_HTML";
